export const Dashboard = axios => ({
  statistic (slug) {
    return axios.get(`/v1/profiles/${slug}/aggregates/dashboard`)
  },
  processes (slug) {
    return axios.get(`/v1/profiles/${slug}/aggregates/dashboard-processes`)
  }
})
